import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Button, Box, IconButton, Drawer, List, ListItem } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useTheme, useMediaQuery } from "@mui/material";
import logo2 from "./assets/Images/logo2.png";

const Header = ({ setIsAdmin }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [active, setActive] = useState(location.pathname);
  const [mobileOpen, setMobileOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // For tablets and smaller screens

  // Update active state when route changes
  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleUserClick = () => {
    if (setIsAdmin) setIsAdmin(false); // Log out
    navigate("/login"); // Redirect to login page
  };

  const menuItems = [
    { label: "Accounts", path: "/Accounts" },
    { label: "Add Workers", path: "/add-workers" },
    { label: "Workers Attendance", path: "/workers-attendance" },
    { label: "Product Management", path: "/product-management" },
    { label: "Bill History", path: "/bill-history" },
    { label: "User", path: "/admin" }, // We'll handle this specially
  ];

  return (
    <AppBar position="static" sx={{ backgroundColor: "#333", padding: "5px 0", height: "60px" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <img src={logo2} alt="Logo" style={{ height: "45px" ,marginTop:"-10px" }} />

        {/* Mobile Menu Button */}
        {isMobile ? (
          <>
            <IconButton color="inherit" edge="end" onClick={handleDrawerToggle}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
              <List sx={{ width: 250, backgroundColor: "black", height: "100%" }}>
                {menuItems.map((item) => (
                  <ListItem key={item.path}>
                    <Button
                      component={Link}
                      to={item.path}
                      sx={{
                        color: active === item.path ? "black" : "white",
                        backgroundColor: active === item.path ? "#fdb913" : "transparent",
                        fontWeight: "bold",
                        width: "100%",
                        textAlign: "center",
                      }}
                      onClick={() => {
                        setActive(item.path);
                        setMobileOpen(false);
                      }}
                    >
                      {item.label}
                    </Button>
                  </ListItem>
                ))}
              </List>
            </Drawer>
          </>
        ) : (
          <Box sx={{ display: "flex", gap: "10px" }}>
            {menuItems.map((item) => (
              <Button
                key={item.path}
                component={item.label === "User" ? undefined : Link}
                to={item.label === "User" ? undefined : item.path}
                sx={{
                  color: active === item.path ? "black" : "white",
                  backgroundColor: active === item.path ? "#fdb913" : "transparent",
                  fontSize: "19px",
                  fontWeight: "bold",
                  paddingTop: "15px",
                  paddingBottom: "12px",
                  fontFamily: "'Solitas Serif Cond Demi', serif",
                  position: "relative",
                  top: 5,
                  width: "auto",
                }}
                onClick={
                  item.label === "User"
                    ? handleUserClick
                    : () => setActive(item.path)
                }
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
